import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  // Box,
  // Divider,
  // FormControl,
  // InputLabel,
  // MenuItem,
  // Select,
  TextField,
  Typography,
  // Typography,
} from "@mui/material";
// import { IconButton } from "@mui/material";

// import React, { useState } from "react";
import "./UserForm.css";
import {
  userlocationData,
  userPermissions,
  // userTypeData,
} from "../../../Data/data";
import ReusableSelect from "../../../components/ReusableSelect/ReusableSelect";
import { Grid } from "@mui/material";
import { ErrorMessage, Field, Form, Formik } from "formik";
import ReusableCheckboxSelect from "../../../components/ReusableCheckboxSelect/ReusableCheckboxSelect";
import { useCallback, useEffect } from "react";
import functions from "../../../utils/Api";
import { useDispatch, useSelector } from "react-redux";
import Usertype from "../../UserType/Usertype";
import UsertypeDropdown from "../../../components/UsertypeDropdown/UsertypeDropdown";

import { useNavigate } from "react-router-dom";
import { setUserType } from "../../../Redux/persistApiDataSlice";

const UserForm = ({
  values,
  touched,
  errors,
  userDetails,
  setUserDetails,
  handleUserDetails,
  permissionType,
  setFieldValue,
  setFieldTouched,
  permissionList,
  permissioTypeId,
  title,
}) => {
  const dispatcher = useDispatch();
  const navigate = useNavigate();
  // const locations = useSelector((state) => state.mealAppReducer.locationsList);
  const locations = useSelector((state) => state.persistApiData.locationsList);
  const userTypeData = useSelector(
    (state) => state.persistApiData.userTypeData
  );
  const userType = useSelector((state) => state.persistApiData.userType);

  const selector = useSelector((state) => state.report);

  const handlePermission = useCallback(
    (value) => {
      const filteredPermissions =
        value === 3
          ? permissionList.filter((item) => item.permissionId === 1)
          : [];
      setUserDetails((prev) => ({
        ...prev,
        roleId: value,
        permission: filteredPermissions,
      }));
      // Ensure Formik state is updated properly
      setFieldValue(
        "permission",
        filteredPermissions.length > 0 ? filteredPermissions : []
      );
    },
    [permissionList, setFieldValue, setUserDetails]
  );

  useEffect(() => {
    if (userDetails.roleId === 3) {
      handlePermission(3);
    }
  }, [handlePermission, userDetails.roleId]);

  const handleRedirect = (e) => {
    handlePermission(e.target.value);
    dispatcher(setUserType(e.target.value));
    handleRedirectUser(e.target.value);
  };

  function handleRedirectUser(value) {
    if (title === "Add") {
      if ([1, 3].includes(value)) {
        navigate("/cms/add-user");
      }
      if (value === 2) {
        navigate("/cms/add-vendor");
      }
    }
  }

  return (
    <>
      <Grid container spacing={4}>
        <Grid item lg={6}>
          <UsertypeDropdown
            title={title}
            value={userDetails.roleId ? userDetails.roleId : userType}
            data={userTypeData}
            handleChange={handleRedirect}
          />
        </Grid>
        <Grid item lg={6}>
          <FormControl
            fullWidth
            error={touched.officeLocationId && Boolean(errors.officeLocationId)}
            // sx={{ m:  }}
            size="small"
          >
            <InputLabel id="locationType-label">Select Location</InputLabel>
            <Select
              labelId="locationType-label"
              id="location"
              name="officeLocationId"
              value={values.officeLocationId || ""}
              onChange={(event) => handleUserDetails(event, setFieldValue)}
              onBlur={() => setFieldTouched("officeLocationId", true)}
              label="Select Location"
            >
              {locations.length > 0 &&
                locations.map((item, i) => (
                  <MenuItem key={i} value={item.locationId}>
                    {item.displayName}
                  </MenuItem>
                ))}
            </Select>
            {touched.officeLocationId && errors.officeLocationId && (
              <Typography
                variant="body2"
                color="error"
                sx={{
                  fontSize: "0.75rem",
                  marginTop: "4px",
                  marginLeft: "10px",
                  color: "#d32f2f",
                  fontFamily: "Lato, sans-serif",
                }}
              >
                {errors.officeLocationId}
              </Typography>
            )}
          </FormControl>
        </Grid>
        {/* <Grid item lg={4}></Grid> */}
        <Grid item lg={6}>
          <Field
            label="First Name"
            fullWidth
            as={TextField}
            placeholder="Enter Employee First Name"
            value={values.firstName}
            name="firstName"
            onChange={(event) => handleUserDetails(event, setFieldValue)}
            size="small"
            error={touched.firstName && Boolean(errors.firstName)}
            helperText={<ErrorMessage name="firstName" />}
            onKeyPress={(e) => {
              const regex = /^[a-zA-Z\s]+$/; // Allow letters and spaces only
              if (!regex.test(e.key)) {
                e.preventDefault(); // Block invalid input
              }
            }}
            inputProps={{
              maxLength: 30,
            }}
          />
        </Grid>
        <Grid item lg={6}>
          <Field
            label="Last Name"
            fullWidth
            as={TextField}
            placeholder="Enter Employee Last Name"
            value={values.lastName}
            name="lastName"
            onChange={(event) => handleUserDetails(event, setFieldValue)}
            size="small"
            error={touched.lastName && Boolean(errors.lastName)}
            helperText={<ErrorMessage name="lastName" />}
            onKeyPress={(e) => {
              const regex = /^[a-zA-Z\s]+$/; // Allow letters and spaces only
              if (!regex.test(e.key)) {
                e.preventDefault(); // Block invalid input
              }
            }}
            inputProps={{
              maxLength: 30,
            }}
          />
        </Grid>
        {userDetails.roleId === 1 && (
          <Grid item lg={6}>
            <Field
              label="Employee Id"
              fullWidth
              as={TextField}
              placeholder="Enter Employee Id"
              value={values.employeeId}
              name="employeeId"
              onChange={(event) => handleUserDetails(event, setFieldValue)}
              size="small"
              error={touched.employeeId && Boolean(errors.employeeId)}
              helperText={<ErrorMessage name="employeeId" />}
              inputProps={{
                maxLength: 50,
              }}
            />
          </Grid>
        )}
        <Grid item lg={6}>
          <Field
            label="Work Email Address"
            fullWidth
            as={TextField}
            placeholder="Enter Employee Work Email Address"
            value={values.email}
            name="email"
            onChange={(event) => handleUserDetails(event, setFieldValue)}
            size="small"
            error={touched.email && Boolean(errors.email)}
            helperText={<ErrorMessage name="email" />}
          />
        </Grid>
        {title !== "Update" && (
          <Grid item lg={6}>
            <Field
              label="Password"
              fullWidth
              as={TextField}
              placeholder="Enter Password"
              value={values.password}
              name="password"
              onChange={(event) => handleUserDetails(event, setFieldValue)}
              size="small"
              error={touched.password && Boolean(errors.password)}
              helperText={<ErrorMessage name="password" />}
            />
          </Grid>
        )}
        {/* <Grid item lg={4}></Grid> */}
        <Grid item lg={6}>
          <Field
            label="Phone Number"
            fullWidth
            as={TextField}
            placeholder="Enter Phone Number"
            value={values.contactNumber}
            name="contactNumber"
            onChange={(event) => {
              handleUserDetails(event, setFieldValue);
            }}
            onInput={(e) => {
              // Limit to 10 digits
              if (e.target.value.length > 10) {
                e.target.value = e.target.value.slice(0, 10);
              }
            }}
            onKeyPress={(e) => {
              // Prevent non-numeric characters
              if (!/[0-9]/.test(e.key)) {
                e.preventDefault();
              }
            }}
            size="small"
            error={touched.contactNumber && Boolean(errors.contactNumber)}
            helperText={<ErrorMessage name="contactNumber" />}
          />
        </Grid>
        <Grid item lg={6}>
          <Field
            label="Enter Designation"
            fullWidth
            as={TextField}
            placeholder="Enter Designation"
            value={values.designation}
            name="designation"
            onChange={(event) => handleUserDetails(event, setFieldValue)}
            size="small"
            error={touched.designation && Boolean(errors.designation)}
            helperText={<ErrorMessage name="designation" />}
            inputProps={{
              maxLength: 70,
            }}
          />
        </Grid>
        {/* <Grid item lg={4}></Grid> */}
        <Grid item lg={6} className="userform-multiselect">
          <Field
            as={ReusableCheckboxSelect}
            name="permission"
            selected={values.permission}
            userDetails={userDetails}
            data={
              userDetails.roleId === 3
                ? permissionList.filter((item) => item.permissionId === 1)
                : permissionList.length > 0
                ? permissionList
                : []
            }
            handleChange={handleUserDetails}
            setFieldValue={setFieldValue}
            setFieldTouched={setFieldTouched}
            touched={touched}
            errors={errors}
            setUserDetails={setUserDetails}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default UserForm;
